import { type IntegrationResponse } from "../api";
import { Utility } from "./utility";

export interface Integration extends IntegrationResponse {}

export class Integration extends Utility<Integration> {
  constructor(init?: Partial<IntegrationResponse>) {
    super();
    Object.assign(this, init);
  }
}
